// actions/adminNotificationActions.js
import axios from "../helpers/axios";
import { adminNotificationConstants as C } from "./constants";
import { getSocket, refreshAdminSocketAuth } from "../containers/ChatPage/socket";
import { playDing, speak } from "../utils/notifyAudio";

let isSubscribed = false;
let handleNew;

// === Получить все уведомления ===
export const fetchAdminNotifications = () => async (dispatch) => {
    try {
        const res = await axios.get("/admin/notifications");
        if (res.status === 200) {
            dispatch({ type: C.FETCH_SUCCESS, payload: res.data.notifications });
        }
    } catch (e) {
        console.error("Ошибка получения уведомлений:", e);
    }
};

export const resetAndLoadFirstPage = (filtersPatch = {}) => async (dispatch, getState) => {
    // сохранить фильтры
    dispatch({ type: C.SET_FILTERS, payload: filtersPatch });
    // сбросить список
    dispatch({ type: C.RESET_LIST });

    const { filters } = getState().notification;
    await dispatch(loadNextPage()); // подтянет с учётом state.filters
};

// догрузить следующую страницу по курсору
export const loadNextPage = () => async (dispatch, getState) => {
    const { nextCursor, hasMore, filters } = getState().notification;
    if (!hasMore) return;

    const params = {
        limit: filters.limit,
        sort: filters.sort,
        from: filters.from || undefined,
        to: filters.to || undefined,
        cursor: nextCursor || undefined,
    };

    const res = await axios.get("/admin/notifications", { params });
    if (res.status === 200) {
        const { notifications, paging } = res.data;
        dispatch({
            type: C.FETCH_PAGE_SUCCESS,
            payload: {
                items: notifications,
                nextCursor: paging?.nextCursor || null,
                hasMore: !!paging?.hasMore,
            },
        });
    }
};

// отметить как прочитанное (как было)
export const markAdminNotificationRead = (id) => async (dispatch) => {
    try {
        const res = await axios.put(`/admin/notifications/read/${id}`);
        if (res.status === 200) {
            dispatch({ type: C.MARK_READ, payload: id });
        }
    } catch (e) {
        console.error("Ошибка отметки уведомления:", e);
    }
};

// === Основной обработчик ===
const createHandler = (dispatch) => (data) => {
    console.log("📨 Новое уведомление:", data);

    dispatch({ type: C.RECEIVED, payload: data });

    // звук и голос только если вкладка активна
    if (!document.hidden) {
        playDing();
        speak("Новый заказ создан");
    } else {
        console.log("🔕 Вкладка неактивна — звук не воспроизводится");
    }

    // тост для локального интерфейса
    try {
        window.dispatchEvent(new CustomEvent("admin-toast", { detail: data }));
    } catch (e) {
        console.warn("Ошибка при вызове admin-toast", e);
    }

    // системное уведомление (если вкладка неактивна)
    if (document.hidden && "Notification" in window) {
        if (Notification.permission === "granted") {
            new Notification(data.title || "Новое уведомление", {
                body: data.message || "Откройте админку",
                icon: "/favicon.ico",
            });
        } else if (Notification.permission !== "denied") {
            Notification.requestPermission().then((perm) => {
                if (perm === "granted") {
                    new Notification(data.title || "Новое уведомление", {
                        body: data.message || "Откройте админку",
                        icon: "/favicon.ico",
                    });
                }
            });
        }
    }
};

// === Подписка на уведомления (один раз) ===
export const subscribeAdminNotifications = () => (dispatch) => {
    if (isSubscribed) return;

    const socket = getSocket();
    refreshAdminSocketAuth();

    // при реконнекте — снова присоединяемся
    const joinAdmins = () => {
        socket.emit("admin:join");
        console.log("🔔 Присоединились к комнате admins");
    };

    socket.off("connect", joinAdmins);
    socket.on("connect", joinAdmins);

    if (socket.connected) {
        joinAdmins();
    }

    if (!handleNew) handleNew = createHandler(dispatch);

    // снимаем предыдущий listener и навешиваем новый
    socket.off("admin:notification:new", handleNew);
    socket.on("admin:notification:new", handleNew);

    isSubscribed = true;
    console.log("📡 Подписка на admin:notification:new активна");

    // очистка при hot reload (dev)
    if (import.meta.hot) {
        import.meta.hot.dispose(() => {
            socket.off("admin:notification:new", handleNew);
            isSubscribed = false;
            console.log("♻️ Сброшена подписка (HMR reload)");
        });
    }
};

// === Создать тестовое уведомление ===
export const createAdminOrderNotification = () => async (dispatch) => {
    try {
        const res = await axios.post("/admin/notifications", {
            type: "order",
            title: "Новый заказ",
            message: "Новый заказ создан",
            link: "/admin/orders",
        });

        if (res.status === 201) {
            const n = res.data.notification;
            dispatch({ type: C.RECEIVED, payload: n });
            playDing();
            speak("Новый заказ создан");
            window.dispatchEvent(new CustomEvent("admin-toast", { detail: n }));
        }
    } catch (e) {
        console.error("Ошибка создания тестового уведомления:", e);
    }
};
